// Error raised while tokenizing or parsing a chart formula.
// `key` is an i18n key and `params` its interpolation values.
class FormulaError extends Error {
  constructor(key, pos = null, params = {}) {
    super(key);
    this.name = 'FormulaError';
    this.key = key;
    this.pos = pos;
    this.params = params;
  }

  translate() {
    return I18n.t(this.key, { ...this.params, pos: (this.pos ?? 0) + 1 });
  }
}

export default FormulaError;
